"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76698],{

/***/ 581016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ DateTimePicker; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-picker-minimal-virtual-8447c4967d/0/cache/rc-picker-minimal-npm-2.6.12-23ef8ea91e-940940dbf0.zip/node_modules/rc-picker-minimal/es/index.js + 51 modules
var es = __webpack_require__(769238);
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-picker-minimal-virtual-8447c4967d/0/cache/rc-picker-minimal-npm-2.6.12-23ef8ea91e-940940dbf0.zip/node_modules/rc-picker-minimal/lib/generate/dateFns.js
var dateFns = __webpack_require__(471953);
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-picker-minimal-virtual-8447c4967d/0/cache/rc-picker-minimal-npm-2.6.12-23ef8ea91e-940940dbf0.zip/node_modules/rc-picker-minimal/lib/locale/en_US.js
var en_US = __webpack_require__(651945);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/BackOutlined.es.js
var BackOutlined_es = __webpack_require__(431529);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ForwardOutlined.es.js
var ForwardOutlined_es = __webpack_require__(622746);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/JumpBackOutlined.es.js
var JumpBackOutlined_es = __webpack_require__(707536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/JumpForwardOutlined.es.js
var JumpForwardOutlined_es = __webpack_require__(887881);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ClockAlternativeOutlined.es.js
var ClockAlternativeOutlined_es = __webpack_require__(753954);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CalendarOutlined.es.js
var CalendarOutlined_es = __webpack_require__(839746);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DeleteCircleFilled.es.js
var DeleteCircleFilled_es = __webpack_require__(252661);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ArrowDownTinyFilled.es.js
var ArrowDownTinyFilled_es = __webpack_require__(96121);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(640128);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/DateTimePicker/style.es.js


const Wrapper = emotion_styled_browser_esm["default"].div(({ theme }) => [
  index_es/* CommonStyles */.F,
  `
  padding-left: ${theme == null ? void 0 : theme.spacing.s8};
  padding-right: ${theme == null ? void 0 : theme.spacing.s8};
  border: ${theme == null ? void 0 : theme.borderWeight.m} solid ${theme == null ? void 0 : theme.colors.border};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  width: fit-content;
  height: 40px;
  display: flex;
  justify-content: space-between;
  > * {
    align-self: center;
  }

  .rc-picker {
    margin-left: ${theme == null ? void 0 : theme.spacing.s4};
    &.rc-picker-focused {
      border: none;
    }
    .rc-picker-input {
      > input {
        border: none;
        &:focus {
          outline: none;
        }
      }

      .rc-picker-clear {
        right: 0;
      }
    }
    .rc-picker-dropdown {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5715;
      list-style: none;
      font-feature-settings: 'tnum';
      position: absolute;
      z-index: 1050;
      box-shadow: none !important;
    }
    
    .rc-picker-panel-container {
      overflow: hidden;
      vertical-align: top;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
      transition: margin 0.3s;
    
      .rc-picker-panel {
        vertical-align: top;
        background: 0 0;
        border-radius: 0;
        display: inline-flex;
        flex-direction: column;
        text-align: center;
        background: #fff;
        outline: none;
        border: none;
      }
    }
    
    .rc-picker-header {
      display: flex;
      padding: 0 8px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #f0f0f0;
    }
    
    .rc-picker-header-view {
      flex: auto;
      font-weight: 500;
      line-height: 40px;
    
      button {
        color: inherit;
        font-weight: inherit;
        padding: 0;
        line-height: 40px;
        background: 0 0;
        border: 0;
        cursor: pointer;
        transition: color 0.3s;
    
        &:not(:first-of-type) {
          margin-left: 8px;
        }
      }
    }
    
    .rc-picker-header > button {
      min-width: 1.6em;
      padding: 0;
      color: rgba(0, 0, 0, 0.25);
      line-height: 40px;
      background: 0 0;
      border: 0;
      cursor: pointer;
      transition: color 0.3s;
    }
    
    .rc-picker-body {
      padding: 8px 12px;
    
      .rc-picker-content {
        width: 252px;
      }
    }
    
    .rc-picker-panel .rc-picker-footer {
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
    }
    
    .rc-picker-ranges {
      margin-bottom: 0;
      padding: 4px 12px !important;
      overflow: hidden;
      line-height: 34px;
      text-align: left;
      list-style: none;
    
      > li {
        display: inline-block;
      }
    }
    
    .rc-picker-now {
      text-align: left;
    }
    
    .rc-picker-ranges .rc-picker-ok {
      float: right;
      margin-left: 8px;
    }
    
    .rc-picker-dropdown .rc-picker-panel > .rc-picker-time-panel {
      padding-top: 4px;
    }
    
    .rc-picker-time-panel-column {
      flex: 1 0 auto;
      width: 56px !important;
      margin: 0;
      padding: 0;
      overflow-y: hidden;
      text-align: left;
      list-style: none;
      transition: background 0.3s;
    
      > li.rc-picker-time-panel-cell-selected .rc-picker-time-panel-cell-inner {
        background: #e6f7ff;
      }
    }
    
    .rc-picker-cell-inner, .rc-picker-time-panel-cell-inner {
      font-size: 14px;
    }
    
    .rc-picker-now-btn, .rc-picker-today-btn {
      cursor: pointer;
      color: #1890ff !important;
    }
    
    .rc-picker-time-panel-cell-inner:hover {
      background: #f5f5f5;
    }
    
    .rc-picker-cell-inner:hover {
      background-color: #f5f5f5 !important;
    }

    .rc-picker-time-panel-column:hover {
      overflow-y: auto;
    }
  }
`
]);



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/DateTimePicker/DateTimePicker.es.js








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CustomButton = (props) => /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadValues({
  size: "s"
}, props), "Xong");
const DateTimePicker = (_a) => {
  var _b = _a, {
    value,
    format,
    onChange = () => {
    },
    type = "date",
    placeholder,
    disabledDate,
    disabledTime,
    showTime
  } = _b, rest = __objRest(_b, [
    "value",
    "format",
    "onChange",
    "type",
    "placeholder",
    "disabledDate",
    "disabledTime",
    "showTime"
  ]);
  let configs;
  configs = {
    generateConfig: dateFns/* default */.Z,
    locale: en_US/* default */.Z,
    prevIcon: /* @__PURE__ */ react.createElement(BackOutlined_es/* BackOutlined */.Y, null),
    nextIcon: /* @__PURE__ */ react.createElement(ForwardOutlined_es/* ForwardOutlined */.d, null),
    superPrevIcon: /* @__PURE__ */ react.createElement(JumpBackOutlined_es/* JumpBackOutlined */.g, null),
    superNextIcon: /* @__PURE__ */ react.createElement(JumpForwardOutlined_es/* JumpForwardOutlined */.Z, null)
  };
  switch (type) {
    case "time":
      configs = __spreadProps(__spreadValues({}, configs), {
        picker: "time",
        placeholder: placeholder || "00:00:00",
        format: format || "HH:mm:ss"
      });
      break;
    case "datetime":
      configs = __spreadProps(__spreadValues({}, configs), {
        showTime: true,
        placeholder: placeholder || "dd/mm/yyyy hh:mm:ss",
        format: format || "dd/MM/yyyy HH:mm:ss"
      });
      break;
    default:
      configs = __spreadProps(__spreadValues({}, configs), {
        picker: "date",
        placeholder: placeholder || "dd/mm/yyyy",
        format: format || "dd/MM/yyyy"
      });
  }
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadValues({}, rest), type === "time" ? /* @__PURE__ */ react.createElement(ClockAlternativeOutlined_es/* ClockAlternativeOutlined */.I, {
    size: 24
  }) : /* @__PURE__ */ react.createElement(CalendarOutlined_es/* CalendarOutlined */.I, {
    size: 24
  }), /* @__PURE__ */ react.createElement(es/* default */.ZP, __spreadProps(__spreadValues({}, configs), {
    onChange: (val) => {
      onChange(val);
    },
    value,
    allowClear: true,
    clearIcon: /* @__PURE__ */ react.createElement(DeleteCircleFilled_es/* DeleteCircleFilled */.N, {
      size: 20,
      onClick: (e) => {
        e.stopPropagation();
        onChange(void 0);
      }
    }),
    suffixIcon: !value && /* @__PURE__ */ react.createElement(ArrowDownTinyFilled_es/* ArrowDownTinyFilled */.x, null),
    showToday: true,
    components: {
      button: CustomButton
    },
    dropdownAlign: {
      offset: [-36, 12]
    },
    getPopupContainer: (triggerNode) => triggerNode,
    disabledDate,
    disabledTime,
    showTime
  })));
};




/***/ }),

/***/ 96121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ArrowDownTinyFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ArrowDownTinyFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M18.8747 7.5H5.12475C5.01092 7.50004 4.89927 7.52494 4.80184 7.57203C4.70441 7.61911 4.6249 7.68659 4.5719 7.76718C4.51889 7.84777 4.4944 7.93841 4.50107 8.02932C4.50774 8.12023 4.54532 8.20795 4.60975 8.28303L11.4847 16.2833C11.5422 16.3501 11.6191 16.4048 11.7088 16.4425C11.7985 16.4803 11.8984 16.5 11.9997 16.5C12.1011 16.5 12.201 16.4803 12.2907 16.4425C12.3804 16.4048 12.4573 16.3501 12.5147 16.2833L19.3897 8.28303C19.4542 8.20795 19.4917 8.12023 19.4984 8.02932C19.5051 7.93841 19.4806 7.84777 19.4276 7.76718C19.3746 7.68659 19.2951 7.61911 19.1977 7.57203C19.1002 7.52494 18.9886 7.50004 18.8747 7.5Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "15",
                  height: "15",
                  fill: "white",
                  transform: "translate(4.5 4.5)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 839746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CalendarOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CalendarOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.9674 4.43457C17.9674 4.02036 17.6316 3.68457 17.2174 3.68457C16.8032 3.68457 16.4674 4.02036 16.4674 4.43457V5H7.53261V4.43457C7.53261 4.02036 7.19682 3.68457 6.78261 3.68457C6.36839 3.68457 6.03261 4.02036 6.03261 4.43457V5H4.75C3.23122 5 2 6.23122 2 7.75V18.25C2 19.7688 3.23122 21 4.75 21H19.25C20.7688 21 22 19.7688 22 18.25V7.75C22 6.23122 20.7688 5 19.25 5H17.9674V4.43457ZM6.03261 6.5H4.75C4.05964 6.5 3.5 7.05964 3.5 7.75V9.25H20.5V7.75C20.5 7.05964 19.9404 6.5 19.25 6.5H17.9674V7.04327C17.9674 7.45748 17.6316 7.79327 17.2174 7.79327C16.8032 7.79327 16.4674 7.45748 16.4674 7.04327V6.5H7.53261V7.04327C7.53261 7.45748 7.19682 7.79327 6.78261 7.79327C6.36839 7.79327 6.03261 7.45748 6.03261 7.04327V6.5ZM3.5 10.75H20.5V18.25C20.5 18.9404 19.9404 19.5 19.25 19.5H4.75C4.05964 19.5 3.5 18.9404 3.5 18.25V10.75Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 707536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ JumpBackOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const JumpBackOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7803 5.53033C13.0732 5.23744 13.0732 4.76256 12.7803 4.46967C12.4874 4.17678 12.0126 4.17678 11.7197 4.46967L4.71967 11.4697C4.42678 11.7626 4.42678 12.2374 4.71967 12.5303L11.7197 19.5303C12.0126 19.8232 12.4874 19.8232 12.7803 19.5303C13.0732 19.2374 13.0732 18.7626 12.7803 18.4697L6.31066 12L12.7803 5.53033ZM18.7803 5.53033C19.0732 5.23744 19.0732 4.76256 18.7803 4.46967C18.4874 4.17678 18.0126 4.17678 17.7197 4.46967L10.7197 11.4697C10.4268 11.7626 10.4268 12.2374 10.7197 12.5303L17.7197 19.5303C18.0126 19.8232 18.4874 19.8232 18.7803 19.5303C19.0732 19.2374 19.0732 18.7626 18.7803 18.4697L12.3107 12L18.7803 5.53033Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 887881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JumpForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const JumpForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.21967 18.7197C4.92678 19.0126 4.92678 19.4874 5.21967 19.7803C5.51256 20.0732 5.98744 20.0732 6.28033 19.7803L13.2803 12.7803C13.5732 12.4874 13.5732 12.0126 13.2803 11.7197L6.28033 4.71967C5.98744 4.42678 5.51256 4.42678 5.21967 4.71967C4.92678 5.01256 4.92678 5.48744 5.21967 5.78033L11.6893 12.25L5.21967 18.7197ZM11.2197 18.7197C10.9268 19.0126 10.9268 19.4874 11.2197 19.7803C11.5126 20.0732 11.9874 20.0732 12.2803 19.7803L19.2803 12.7803C19.5732 12.4874 19.5732 12.0126 19.2803 11.7197L12.2803 4.71967C11.9874 4.42678 11.5126 4.42678 11.2197 4.71967C10.9268 5.01256 10.9268 5.48744 11.2197 5.78033L17.6893 12.25L11.2197 18.7197Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 293152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useProfile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106454);




const useProfile = ({
  userService
}) => {
  const [loadingProfile, setLoadingProfile] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .useLoading */ .r$)("useProfile");
  const [customerTypes, setCustomerTypes] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const fetchCustomerTypes = async (params = { pageSize: 50 }) => {
    var _a;
    try {
      setLoadingProfile(true);
      const listCustomerTypes = await userService.customerTypes(params);
      const customerTypesArray = ((_a = listCustomerTypes == null ? void 0 : listCustomerTypes.result) == null ? void 0 : _a.customerTypes) || [];
      setCustomerTypes(customerTypesArray.map((item) => ({
        value: item.id,
        text: item.display
      })));
    } catch (e) {
      _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
      setCustomerTypes([]);
    } finally {
      setLoadingProfile(false);
    }
  };
  return {
    loadingProfile,
    customerTypes,
    fetchCustomerTypes
  };
};




/***/ }),

/***/ 589561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledInput = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input`
  display: block;
  width: 100%;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #e0e0e0;
  min-height: 16px;
  &:focus {
    outline: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  &:-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Input = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({}, props));




/***/ }),

/***/ 894050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ FormInputVariants; },
/* harmony export */   "y": function() { return /* binding */ FormInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(589561);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var FormInputVariants = /* @__PURE__ */ ((FormInputVariants2) => {
  FormInputVariants2["valid"] = "valid";
  FormInputVariants2["invalid"] = "invalid";
  return FormInputVariants2;
})(FormInputVariants || {});
const getColor = (props) => {
  switch (props.variant) {
    case "invalid" /* invalid */:
      return "#dc3545";
    case "valid" /* valid */:
      return "#28a745";
  }
};
const Label = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((props) => {
  const styles = {
    fontWeight: 500,
    lineHeight: "24px",
    marginBottom: "4px",
    fontSize: "13px"
  };
  if (props.required) {
    styles["&:after"] = {
      content: '"*"',
      color: "red",
      marginLeft: "0.5em"
    };
  }
  return styles;
});
const Feedback = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((props) => {
  const styles = {};
  if (getColor(props)) {
    styles.color = getColor(props);
    styles.marginTop = "0.25rem";
  }
  return styles;
});
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .I)((props) => {
  const styles = {};
  styles.height = `40px`;
  if (getColor(props)) {
    styles.borderColor = `${getColor(props)} !important`;
  }
  return styles;
});
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const FormInput = (_a) => {
  var _b = _a, {
    label,
    feedback,
    variant,
    required = false,
    children
  } = _b, props = __objRest(_b, [
    "label",
    "feedback",
    "variant",
    "required",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), label && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    required,
    className: "form-input__label"
  }, label), children ? children : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadProps(__spreadValues({}, props), {
    variant,
    className: "form-input__input"
  })), feedback && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Feedback, {
    variant
  }, feedback));
};




/***/ }),

/***/ 258758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ OtpInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const StyledInput = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input`
  width: 42.5px;
  height: 42.5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  outline: none;
  margin-top: 40px;
  margin-bottom: 25px;
  &:focus {
    border: 1px solid #eb1f3a;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const OptWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: flex;
  justify-content: space-between;
`;
const SingleOtpInput = (_a) => {
  var _b = _a, { isFocus } = _b, rest = __objRest(_b, ["isFocus"]);
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (isFocus && ref.current) {
      ref.current.focus();
    }
  }, [isFocus]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadProps(__spreadValues({
    type: "number"
  }, rest), {
    ref
  }));
};
const OtpInput = ({
  onChange,
  className
}) => {
  const [otp, setOtp] = react__WEBPACK_IMPORTED_MODULE_0__.useState(["", "", "", "", "", ""]);
  const [currentFocus, setCurrentFocus] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (onChange)
      onChange(otp.join(""));
  }, [JSON.stringify(otp)]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptWrapper, {
    className
  }, otp.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SingleOtpInput, {
    key: index,
    value: otp[index],
    isFocus: currentFocus === index,
    onFocus: (e) => {
      setCurrentFocus(index);
      const temp = e.target.value;
      e.target.value = "";
      e.target.value = temp;
    },
    onChange: (e) => {
      const length = e.target.value.length;
      const value = e.target.value.slice(length - 1, length);
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index !== otp.length - 1)
        setCurrentFocus((prev) => prev + 1);
    },
    onKeyDown: (e) => {
      const handleDelete = (e2) => {
        e2.preventDefault();
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      };
      switch (e.keyCode) {
        case BACKSPACE:
          handleDelete(e);
          setCurrentFocus((prev) => prev !== 0 ? prev - 1 : prev);
          break;
        case DELETE:
          handleDelete(e);
          break;
        case LEFT_ARROW:
          setCurrentFocus((prev) => prev !== 0 ? prev - 1 : prev);
          break;
        case RIGHT_ARROW:
          setCurrentFocus((prev) => prev !== otp.length - 1 ? prev + 1 : prev);
          break;
      }
    }
  })));
};




/***/ }),

/***/ 573756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useUploadProfile; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(106454);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(175007);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(432054);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(775002);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(983546);
/* harmony import */ var _teko_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(799278);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










const TOTAL_COUNTDOWN = 60;
/**
 * upload/update profile hook
 * @param props ignore verifyPhone or verifyEmail also ignore OTP verifying for that field.
 */ const useUploadProfile = (param)=>{
    let { customRequireFields ={} , uploadProfile , verifyPhone , verifyEmail  } = param;
    const { 0: intervalId , 1: setIntervalId  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { authService , userService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .useLoading */ .r$)();
    const { 0: countdown , 1: setCountdown  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const { 0: otpData , 1: setOTPData  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { 0: otpError , 1: setOTPError  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { 0: message , 1: setMessage  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        success: false,
        content: ""
    });
    const { 0: feedbacks , 1: setFeedbacks  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({});
    const { 0: allowCustomerEditProfile , 1: setAllowCustomerEditProfile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const { 0: requiredFields , 1: setRequiredFields  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(customRequireFields);
    const { user: profile  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)();
    const shouldVerifyEmail = !!verifyEmail;
    const shouldVerifyTelephone = !!verifyPhone;
    const waitingVerifyOTP = !!otpData && Object.values(otpData).some((value)=>!!value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        userService.getClient().then((clients)=>{
            const { requiredProfileInformation , customerCanEditProfile  } = clients[0];
            setAllowCustomerEditProfile(customerCanEditProfile === false ? false : true);
            if (!requiredProfileInformation) return;
            const { phone  } = requiredProfileInformation, others = _objectWithoutProperties(requiredProfileInformation, [
                "phone"
            ]);
            setRequiredFields(_objectSpread({
                telephone: phone
            }, others, customRequireFields));
        }).catch((error)=>_teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error));
    }, [
        userService
    ]);
    const setSuccessMessage = (msg)=>setMessage({
            success: true,
            content: msg
        });
    const setFailureMessage = (msg)=>setMessage({
            success: false,
            content: msg
        });
    const resetStates = ()=>{
        setMessage({
            success: true,
            content: ""
        });
        setFeedbacks({});
        setOTPError(null);
        setOTPData(null);
        setCountdown(0);
        clearInterval(intervalId);
    };
    const validate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((data)=>{
        const validationErrors = {};
        // check for required values
        Object.entries(requiredFields).map((param)=>{
            let [field, isRequired] = param;
            if (isRequired && Object.keys(data).includes(field) && !data[field]) {
                validationErrors[field] = (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Vui l\xf2ng nhập th\xf4ng tin");
            }
        });
        if (data.telephone && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_7__/* .isValidPhoneFormat */ .Ew)(data.telephone)) {
            validationErrors.telephone = (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Vui l\xf2ng nhập số điện thoại đ\xfang định dạng");
        }
        if (data.email && !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_7__/* .isValidEmailFormat */ .HY)(data.email)) {
            validationErrors.email = (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Vui l\xf2ng nhập email đ\xfang định dạng");
        }
        if (data.dob) {
            const parsedDob = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(data.dob);
            if (parsedDob > new Date() || parsedDob < new Date("1/1/1900")) {
                validationErrors.dob = (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Ng\xe0y sinh kh\xf4ng hợp lệ");
            }
        }
        setFeedbacks(validationErrors);
        return validationErrors;
    }, [
        requiredFields
    ]);
    const submit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (data)=>{
        try {
            const payload = {};
            // only send changed fields
            Object.entries((0,_teko_utils__WEBPACK_IMPORTED_MODULE_9__.cleanObject)(data)).forEach((param)=>{
                let [key, value] = param;
                if (data[key] != (profile === null || profile === void 0 ? void 0 : profile[key])) {
                    payload[key] = value;
                }
            });
            const errors = validate(payload);
            if (Object.keys(payload).length > 0 && Object.keys(errors).length <= 0) {
                setLoading(true);
                const res = await uploadProfile(payload);
                setSuccessMessage((0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Cập nhật th\xf4ng tin người d\xf9ng th\xe0nh c\xf4ng"));
                return res;
            }
            return null;
        } catch (e) {
            var ref;
            if (e instanceof _teko_api__WEBPACK_IMPORTED_MODULE_2__.ApiError && ((ref = e.response) === null || ref === void 0 ? void 0 : ref.hasOwnProperty("schema_errors"))) {
                setFailureMessage((0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Th\xf4ng tin kh\xf4ng hơp lệ"));
                const errors1 = {};
                const schemaErrors = e.response.schema_errors;
                // join every error per field into one string splitted by \n character
                Object.entries(schemaErrors).forEach((param)=>{
                    let [key, value] = param;
                    errors1[key] = value.join("\n");
                });
                setFeedbacks(errors1);
            } else {
                setFailureMessage((0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Đ\xe3 c\xf3 lỗi xảy ra!"));
            }
        } finally{
            setLoading(false);
        }
    }, [
        validate,
        profile,
        setLoading,
        uploadProfile
    ]);
    const sendOTP = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (data)=>{
        try {
            const errors = validate(data);
            if (Object.keys(errors).length > 0) return;
            const { email , telephone  } = data;
            const otpType = telephone && shouldVerifyTelephone ? "telephone" : email && shouldVerifyEmail ? "email" : null;
            if (!otpType) return;
            setLoading(true);
            const verifyPromise = otpType === "telephone" ? authService.verifyPhone(telephone !== null && telephone !== void 0 ? telephone : "") : authService.verifyEmail(email !== null && email !== void 0 ? email : "");
            await verifyPromise;
            setOTPData(data);
            // Init timer allow resending otp after 60s
            setCountdown(TOTAL_COUNTDOWN);
            const handle = setInterval(()=>{
                setCountdown((countdown)=>countdown === 0 ? countdown : countdown - 1);
            }, 1000);
            setIntervalId(handle);
        } catch (err) {
            setFeedbacks((prevFeedbacks)=>{
                return _objectSpreadProps(_objectSpread({}, prevFeedbacks), {
                    [(data === null || data === void 0 ? void 0 : data.email) ? "email" : "telephone"]: err instanceof _teko_api__WEBPACK_IMPORTED_MODULE_2__.ApiError ? authService.errorMsg(err) : err
                });
            });
        } finally{
            setLoading(false);
            return false;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        authService,
        setLoading,
        validate
    ]);
    const update = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (data)=>{
        resetStates();
        try {
            if (data.telephone && shouldVerifyTelephone) {
                await sendOTP({
                    telephone: data.telephone
                });
                return null;
            } else if (data.email && shouldVerifyEmail) {
                await sendOTP({
                    email: data.email
                });
                return null;
            } else return submit(data);
        } catch (err) {
            setFailureMessage((0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Đ\xe3 c\xf3 lỗi xảy ra!"));
        } finally{
            setLoading(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        resetStates,
        sendOTP,
        setLoading,
        submit
    ]);
    const resendOTP = async ()=>{
        if (otpData) {
            setMessage({
                success: true,
                content: ""
            });
            setOTPError(null);
            setCountdown(0);
            clearInterval(intervalId);
            await sendOTP(otpData);
        }
    };
    const verifyOtp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (OTP, data)=>{
        try {
            if (waitingVerifyOTP && OTP.length === 6) {
                setLoading(true);
                const { email , telephone  } = otpData !== null && otpData !== void 0 ? otpData : {};
                // otpData should only include telephone or email at the same time,
                // otherwise it could update some unexpected field directly into user service.
                if (telephone && shouldVerifyTelephone) {
                    await verifyPhone(telephone, OTP);
                    delete data.telephone;
                } else if (email && shouldVerifyEmail) {
                    await verifyEmail(email, OTP);
                    delete data.email;
                }
                resetStates();
                setOTPData(null);
                setSuccessMessage((0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Cập nhật th\xe0nh c\xf4ng"));
                // update other profile.
                submit(data);
            }
        } catch (err) {
            if (err instanceof _teko_api__WEBPACK_IMPORTED_MODULE_2__.ApiError) {
                setOTPError(authService.errorMsg(err));
            }
        } finally{
            setLoading(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setLoading,
        otpData,
        resetStates,
        submit,
        verifyPhone,
        verifyEmail,
        authService, 
    ]);
    return {
        waitingVerifyOTP,
        loading,
        requiredFields,
        allowEdit: allowCustomerEditProfile,
        otpError,
        otpData,
        setOTPData,
        message,
        feedbacks,
        countdown,
        resendOTP,
        resetStates,
        validate,
        update,
        verifyOtp
    };
};


/***/ }),

/***/ 531356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ GeneralFormikForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(894050);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(771303);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806748);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(479381);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const RenderGeneralFormikForm = (props, ref)=>{
    const { isMobile =false , getInputFields , initialFormValues , requiredFields , feedbacks , messages , validate , submit , getButtonsProps , additionalButtons , policies  } = props, rest = _objectWithoutProperties(props, [
        "isMobile",
        "getInputFields",
        "initialFormValues",
        "requiredFields",
        "feedbacks",
        "messages",
        "validate",
        "submit",
        "getButtonsProps",
        "additionalButtons",
        "policies"
    ]);
    const handleEmptyField = (event, setFieldValue)=>{
        // reset to value before editing
        const savedValue = initialFormValues === null || initialFormValues === void 0 ? void 0 : initialFormValues[event.target.name];
        if (!event.target.value && savedValue && typeof savedValue !== "boolean") {
            setFieldValue(event.target.name, savedValue);
        }
    };
    const handleSubmit = (values, actions)=>{
        submit(values).then(()=>{
            actions.resetForm({
                values,
                touched: {}
            });
        });
    };
    const renderForm = (param)=>{
        let { values , dirty , errors , touched , setFieldTouched , handleSubmit , handleChange , setFieldValue  } = param;
        const buttonProps = getButtonsProps(values, errors, dirty);
        const inputFields = getInputFields(values, setFieldValue);
        const renderButtons = buttonProps.length > 0 ? buttonProps.map((prop, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, _objectSpread({}, prop), index)) : null;
        const onChange = (e)=>{
            const name = e.target.name;
            handleChange(e);
            setFieldTouched(name, initialFormValues[name] !== e.target.value, false);
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", _objectSpreadProps(_objectSpread({
                onSubmit: handleSubmit
            }, rest), {
                children: [
                    messages.filter((message)=>!!message.content).map((message, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Status */ .qb, {
                            success: message.success,
                            children: message.content
                        }, idx)),
                    inputFields.map((_param)=>{
                        var { condition =true , name  } = _param, rest = _objectWithoutProperties(_param, [
                            "condition",
                            "name"
                        ]);
                        return condition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledFormInput */ .YL, _objectSpread({
                            name: name,
                            value: (values === null || values === void 0 ? void 0 : values[name]) || "",
                            onChange: onChange,
                            onBlur: (event)=>{
                                handleEmptyField(event, setFieldValue);
                            },
                            variant: touched[name] && feedbacks[name] ? _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .FormInputVariants.invalid */ .L.invalid : undefined,
                            feedback: touched[name] && feedbacks[name] ? String(feedbacks[name]) : undefined,
                            required: requiredFields[name]
                        }, rest), name) : null;
                    }),
                    additionalButtons ? additionalButtons : null,
                    policies ? policies : null,
                    renderButtons && (!isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonGroup */ .hE, {
                        children: renderButtons
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledBottomNavBar */ .Ok, {
                        zIndex: 99,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ButtonGroup */ .hE, {
                            children: renderButtons
                        })
                    }))
                ]
            }))
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
        innerRef: ref,
        initialValues: initialFormValues,
        onSubmit: handleSubmit,
        validate: validate,
        children: renderForm
    });
};
const GeneralFormikForm = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(RenderGeneralFormikForm);


/***/ }),

/***/ 972376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ OtpConfirmationPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891256);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(811495);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(479381);






const OtpConfirmationPopup = (param)=>{
    let { isMobile , waitingVerifyOTP , values , otpData , countdown , otpError , resendOTP , resetStates , verifyOtp  } = param;
    const bottomSheetType = otpData ? (otpData === null || otpData === void 0 ? void 0 : otpData.email) ? "email" : "telephone" : "";
    const handleHideOTPModal = ()=>resetStates();
    const handleOtpChange = async (otp, formValues)=>{
        if (otp.length === 6) {
            await verifyOtp(otp, formValues);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, {
            width: "31rem",
            visible: waitingVerifyOTP,
            onClose: handleHideOTPModal,
            footer: false,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .ModalHeader */ .x, {
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("X\xe1c nhận"),
                        " ",
                        (otpData === null || otpData === void 0 ? void 0 : otpData.telephone) ? (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("số điện thoại") : "email"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .ModalBody */ .f, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Center */ .M5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Vui l\xf2ng nhập m\xe3 OTP đ\xe3 được gửi đến"),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: values[(otpData === null || otpData === void 0 ? void 0 : otpData.telephone) ? "telephone" : "email"]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledOTPInput */ .Zw, {
                            onChange: (otp)=>handleOtpChange(otp, values)
                        }),
                        otpError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledNoti */ .H0, {
                            children: otpError
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Center */ .M5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ResendOtpBtn */ .AR, {
                                disabled: countdown > 0,
                                variant: "link",
                                onClick: resendOTP,
                                children: countdown === 0 ? (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Gửi lại m\xe3") : (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Gửi lại m\xe3 sau {{countdown}}s", {
                                    countdown: countdown
                                })
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .BottomSheet */ .R, {
            zIndex: 100,
            show: waitingVerifyOTP,
            title: bottomSheetType == "email" ? (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Cập nhật email") : (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Cập nhật số điện thoại"),
            closeBottomSheet: handleHideOTPModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .BottomSheetContent */ .L8, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Vui l\xf2ng nhập m\xe3 OTP đ\xe3 được gửi đến "),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: bottomSheetType && (otpData === null || otpData === void 0 ? void 0 : otpData[bottomSheetType])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledOTPInput */ .Zw, {
                            onChange: (otp)=>handleOtpChange(otp, values)
                        }),
                        otpError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledNoti */ .H0, {
                            children: otpError
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Center */ .M5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ResendOtpBtn */ .AR, {
                                disabled: countdown > 0,
                                onClick: ()=>resendOTP(),
                                children: countdown === 0 ? (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Gửi lại m\xe3") : (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Gửi lại m\xe3 sau {{countdown}}s", {
                                    countdown: countdown
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 520913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ getAddressInputFieldsV2; },
/* harmony export */   "Mv": function() { return /* binding */ getAddressInputFields; },
/* harmony export */   "Sj": function() { return /* binding */ fallbackTransform; },
/* harmony export */   "lK": function() { return /* binding */ getAddressString; },
/* harmony export */   "qE": function() { return /* binding */ getProfileInputFields; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(771303);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(873897);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(581016);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(479381);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(883667);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(189782);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  .rc-picker {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







const getAddressString = (address)=>{
    return [
        address === null || address === void 0 ? void 0 : address.address,
        address === null || address === void 0 ? void 0 : address.wardName,
        address === null || address === void 0 ? void 0 : address.districtName,
        address === null || address === void 0 ? void 0 : address.provinceName, 
    ].filter(Boolean).join(", ");
};
function fallbackTransform(transformFunc, original) {
    if (!!transformFunc) return transformFunc(original);
    else return original;
}
const getProfileInputFields = (values, setFieldValue, profile, partner, customerTypes, notEditCustomerType, allowEdit)=>{
    var ref;
    var ref1;
    return [
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Họ t\xean"),
            name: "name"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Email"),
            name: "email"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Số điện thoại"),
            name: "telephone",
            disabled: !!partner || !!(profile === null || profile === void 0 ? void 0 : profile.telephone)
        },
        {
            type: "date",
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Ng\xe0y sinh"),
            name: "dob",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDate, {
                type: "date",
                onChange: (value)=>{
                    setFieldValue("dob", value && (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new Date(value), types__WEBPACK_IMPORTED_MODULE_4__/* .DateFormat.YMD */ .t.YMD));
                },
                value: values.dob ? new Date(values.dob) : undefined
            })
        },
        {
            condition: !!(customerTypes === null || customerTypes === void 0 ? void 0 : customerTypes.length),
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Loại kh\xe1ch h\xe0ng"),
            name: "customerTypeId",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                disabled: notEditCustomerType || !!(profile === null || profile === void 0 ? void 0 : profile.customerTypeId) && !allowEdit,
                options: customerTypes,
                selectValue: (value)=>// UX4BUYER-4531
                    setFieldValue("customerTypeId", value),
                /* this selector is only rendered if customerTypes not empty
               so fallback value of 0 will not affect. */ value: (ref1 = values.customerTypeId || (customerTypes === null || customerTypes === void 0 ? void 0 : (ref = customerTypes[0]) === null || ref === void 0 ? void 0 : ref.value)) !== null && ref1 !== void 0 ? ref1 : 0
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Giới t\xednh"),
            name: "sex",
            children: [
                {
                    label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Nam"),
                    value: "M"
                },
                {
                    label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Nữ"),
                    value: "F"
                },
                {
                    label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Kh\xe1c"),
                    value: "O"
                }, 
            ].map((param)=>{
                let { label , value  } = param;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledRadio */ .Ks, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                            type: "radio",
                            name: "sex",
                            value: value,
                            disabled: !!(profile === null || profile === void 0 ? void 0 : profile.sex) && !allowEdit
                        }),
                        label
                    ]
                }, value);
            })
        }, 
    ].map((field)=>{
        return _objectSpreadProps(_objectSpread({
            disabled: !!(profile === null || profile === void 0 ? void 0 : profile[field.name]) && !allowEdit
        }, field), {
            name: field.name
        });
    });
};
const getAddressInputFields = (values, setFieldValue, provinces, districts, wards, onProvinceChanged, onDistrictChanged, onWardChanged)=>[
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Tỉnh/Th\xe0nh phố"),
            name: "provinceCode",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                options: provinces.map((item)=>({
                        value: item.code,
                        text: item.name
                    })),
                selectValue: (code)=>{
                    setFieldValue("provinceCode", code);
                    onProvinceChanged(code.toString());
                },
                value: values.provinceCode || ""
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Quận/Huyện"),
            name: "districtCode",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                options: districts.map((item)=>({
                        value: item.code,
                        text: item.name
                    })),
                selectValue: (code)=>{
                    setFieldValue("districtCode", code);
                    onDistrictChanged(code.toString());
                },
                value: values.districtCode || ""
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Phường/X\xe3"),
            name: "wardCode",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                options: wards.map((item)=>({
                        value: item.code,
                        text: item.name
                    })),
                selectValue: (code)=>{
                    setFieldValue("wardCode", code);
                    onWardChanged(code.toString());
                },
                value: values.wardCode || ""
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Địa chỉ cụ thể (Số nh\xe0, t\xean đường...)"),
            name: "address"
        }, 
    ];
const getAddressInputFieldsV2 = (values, setFieldValue, provinces, wards, onProvinceChanged, onWardChanged)=>[
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Tỉnh/Th\xe0nh phố"),
            name: "provinceCode",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                options: provinces.map((item)=>({
                        value: item.code,
                        text: item.title
                    })),
                selectValue: (value)=>{
                    const location = provinces.find((prov)=>prov.code === value);
                    if (location) {
                        setFieldValue("provinceCode", location.code);
                        onProvinceChanged(location.code);
                    }
                },
                value: values.provinceCode || ""
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Phường/X\xe3"),
            name: "wardCode",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Select */ .P, {
                options: wards.map((item)=>({
                        value: item.code,
                        text: item.title
                    })),
                selectValue: (value)=>{
                    const location = wards.find((ward)=>ward.code === value);
                    if (location) {
                        setFieldValue("wardCode", location.code);
                        onWardChanged(location.code);
                    }
                },
                value: values.wardCode || ""
            })
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Địa chỉ cụ thể (Số nh\xe0, t\xean đường...)"),
            name: "address"
        }, 
    ];
const StyledDate = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .DateTimePicker */ .x)(_templateObject());


/***/ }),

/***/ 479381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ SubTitleWrapper; },
/* harmony export */   "AR": function() { return /* binding */ ResendOtpBtn; },
/* harmony export */   "Ei": function() { return /* binding */ Img; },
/* harmony export */   "H0": function() { return /* binding */ StyledNoti; },
/* harmony export */   "Ks": function() { return /* binding */ StyledRadio; },
/* harmony export */   "L8": function() { return /* binding */ BottomSheetContent; },
/* harmony export */   "M5": function() { return /* binding */ Center; },
/* harmony export */   "Ok": function() { return /* binding */ StyledBottomNavBar; },
/* harmony export */   "Rh": function() { return /* binding */ StyledLayout; },
/* harmony export */   "YL": function() { return /* binding */ StyledFormInput; },
/* harmony export */   "Zw": function() { return /* binding */ StyledOTPInput; },
/* harmony export */   "e6": function() { return /* binding */ AvatarArea; },
/* harmony export */   "hE": function() { return /* binding */ ButtonGroup; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jx": function() { return /* binding */ StyledInfo; },
/* harmony export */   "oh": function() { return /* binding */ PlaceHolderBlock; },
/* harmony export */   "qb": function() { return /* binding */ Status; },
/* harmony export */   "rg": function() { return /* binding */ StyledCard; }
/* harmony export */ });
/* unused harmony export Avatar */
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(291692);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(375640);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(319326);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(894050);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(258758);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 16px 32px;\n  height: unset;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  line-height: 20px;\n  width: max-content;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 1rem auto;\n  width: 23rem;\n  input {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  color: #eb1f3a;\n  text-align: center;\n  margin: 1rem auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  margin-right: 60px;\n  input[type='radio'] {\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 16px;\n  width: 100vw;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  padding-top: 12px;\n  padding-left: 16px;\n  padding-bottom: 6px;\n  text-align: left;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  background: white;\n  padding: 16px 32px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: #fff;\n  text-align: center;\n  padding: 16px 32px 0px 32px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  overflow: hidden;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n  padding-bottom: calc(env(safe-area-inset-bottom) + 120px);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 80vh;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  margin-top: 0.5rem;\n  gap: 0.5rem;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


const StyledBottomNavBar = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__/* .BottomNavigationBar */ .S)(_templateObject());
const StyledFormInput = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .FormInput */ .y)(_templateObject1());
const Status = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div((param)=>{
    let { success  } = param;
    return "\n  color: ".concat(success ? "#4BB543" : "#eb1f3a", ";\n  margin-bottom: 0.8rem;\n");
});
const ButtonGroup = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject2());
const ResendOtpBtn = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)(_templateObject3());
const StyledOTPInput = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .OtpInput */ .v)(_templateObject4());
const Center = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject5());
const StyledNoti = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject6());
const StyledRadio = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].label(_templateObject7());
const BottomSheetContent = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject8());
const SubTitleWrapper = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)(_templateObject9());
const Wrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject10());
const AvatarArea = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject11());
const Avatar = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject12());
const Img = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w)(_templateObject13());
const StyledLayout = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Layout */ .A)(_templateObject14());
const StyledCard = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Card */ .Z)(_templateObject15());
const PlaceHolderBlock = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject16());
const StyledInfo = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject17());


/***/ }),

/***/ 189782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OrderBy; },
/* harmony export */   "t": function() { return /* binding */ DateFormat; }
/* harmony export */ });
var OrderBy;
(function(OrderBy) {
    OrderBy["ASC"] = "ASC";
    OrderBy["DESC"] = "DESC";
})(OrderBy || (OrderBy = {}));
var DateFormat;
(function(DateFormat) {
    DateFormat["YMD"] = "yyyy-MM-dd";
})(DateFormat || (DateFormat = {}));


/***/ })

}]);